/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */
import './FixedIncomeResearch.scss';
import React, { Fragment, useEffect, useState } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { ReactComponent as ErrorMessageImage } from 'assets/error-message.svg';

import ThirdPartyFrame from "../../shared/ThirdPartyFrame/ThirdPartyFrame";
import AAMFooterContainer from "../Footer/FooterUtil";
import { getIceSAMLResponse} from 'services/Rest';
import { mapProductTypeToiiFooterBoolean } from 'state/account/AccountSelectors';
import { isMobile } from 'state/view/ViewSelectors';
import { getFixedIncomeSSOData } from 'state/brokerage/BrokerageSelectors';
import { getCustomerWebView } from 'state/customer/CustomerSelectors';
import LegalReferenceNumber from '../LegalReferenceNumber/LegalReferenceNumber';

const FixedIncomeResearch = ({
  isMobileApp,
  footerProductTypes,
  samlData
                             }) => {

  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    getIceSAMLResponse().catch((err) => {
      if (err && err.serviceErrorCode) {
        setHasError(true)
      }
    });

  }, []);

  const { message, containerURL } = samlData;

  return (
    <div className="fixed-income-container beacon-on-darker">
    <Fragment>
      <div className="fixed-income-header-container">
        <div className="temp b-typography-serif--headline--600 b-font-weight-bold">
          Fixed Income Research
        </div>
      </div>
      { hasError && <div className={'error-container'}>
        <ErrorMessageImage className={'error-image'} />
        <h2 className={'b-typography-serif--headline--100'}>Fixed Income Research is currently not available. Please try again later.</h2>
      </div>
      }
      { !hasError && <Fragment>
      <div className={'mobile-disclaimer'}>
        <ErrorMessageImage className={'error-image'} />
        <h2>Fixed Income Research is not available on mobile devices or smaller screens.</h2>
      </div>
        <div className={'fixed-income-research-page-container'}>
          <ThirdPartyFrame
            eligible={!hasError}
            scrolling={'no'}
            name={'ice-container'}
            errorUrl={'/error'}
            message={message}
            containerURL={containerURL}
          />
        </div>
      </Fragment>
      }
    </Fragment>
      <LegalReferenceNumber providedLegalNumber={'4056385'}/>
      <AAMFooterContainer
        isMobileParam={isMobileApp}
        footerProductTypes={footerProductTypes}
        appLoaded
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  footerProductTypes: mapProductTypeToiiFooterBoolean(state),
  isMobileApp: isMobile(state),
  samlData: getFixedIncomeSSOData(state),
  isCustomerWebView: getCustomerWebView(state),
});
export default compose(
  connect(mapStateToProps)
)(FixedIncomeResearch);
